import { defineSmartFeedPiniaStore } from "@bloglovin/vue-framework";
import useFanPublicationStore from "%/stores/fan-publication-store";
import { useCreatorPublicationStore } from "%/stores/creator-publication-store";
import SmartFeedEngine from "~/smart-feed/smart-feed-engine";

const MAX_TIMESTAMP = Number.MAX_SAFE_INTEGER;
export const useEventTempFeedStore = defineSmartFeedPiniaStore("event-temp-feed-store", {
  state: () => ({
    smartFeedEngine: new SmartFeedEngine(),
    tableFields: [
      {
        key: "title",
        label: "Title",
      },
      {
        key: "description",
        label: "Description",
      },
      {
        key: "eventTimestamp",
        label: "Event Date",
      },
      {
        key: "imageUrl",
        label: "Image",
      },
      {
        key: "status",
        label: "Status",
      },
      {
        key: "actions",
        label: "",
      },
    ],
    metadata: {
      lastId: 0,
      eventTimestampFrom: 0,
      eventTimestampTo: MAX_TIMESTAMP,
    },
  }),
  getters: {
    // Lazy read, like event-feed-store: a metadata snapshot can be replaced
    // by reload() overrides, and pre-seed it would freeze publicationId at 0.
    feedUrl() {
      const publicationId = useFanPublicationStore().publicationId
        || useCreatorPublicationStore().publicationId;
      return `events/publication/${publicationId}/temp`;
    },
    smartFeedRequestGetParams() {
      return {
        last_id: this.metadata.lastId,
        event_timestamp_from: this.metadata.eventTimestampFrom,
        event_timestamp_to: this.metadata.eventTimestampTo,
      };
    },
  },
});
